<template>
    <div class="col-md-12">
        <div class="h2">{{ agreement.name }}</div>
        <form @submit.prevent="updateAgreement">
            <div class="p-4 mb-0 bg-white rounded-lg">
                <div class="d-flex justify-content-between">
                    <div class="h4 mb-0">General information</div>
                    <div>
                        <a href="#" class="" @click="isEditing = !isEditing" v-if="!isEditing">
                            <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                        </a>
                    </div>
                </div>

                <div class="pt-3">
                    <div class="container-fluid bg-light py-3">
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-2"><strong> Name: </strong></div>
                                <div class="col-sm-4"><strong> Default pickup address: </strong></div>
                                <div class="col-sm-4"><strong> Default dropoff address: </strong></div>
                                <div class="col-sm-1"><strong> Primary: </strong></div>
                                <div class="col-sm-1"></div>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid bg-light py-3">
                        <div class="row">
                            <div class="col-sm-2">
                                <div
                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.name=='' && isSubmit}">
                                    <input type="text"
                                           autocomplete="off"
                                           required
                                           class="form-control"
                                           placeholder="Name"
                                           v-model="agreement.name" ref="name" :disabled="!isEditing"
                                           :class="{view: !isEditing}">
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div
                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.pickup_address=='' && isSubmit}">
                                        <input type="text" autocomplete="off" required class="form-control"
                                               placeholder="name"
                                               v-model="agreement.pickup_address.name" ref="pickup_address.name"
                                               :disabled="!isEditing"
                                               :class="{view: !isEditing}">
                                        <div class="help-block with-errors"></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div
                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.pickup_address.street=='' && isSubmit}">
                                        <input type="text" autocomplete="off" required class="form-control"
                                               placeholder="Address"
                                               v-model="agreement.pickup_address.street"
                                               ref="pickup_address.billing_street"
                                               :disabled="!isEditing" :class="{view: !isEditing}">
                                        <div class="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-4">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.pickup_address.zip=='' && isSubmit}">
                                                <input type="text" autocomplete="off" required class="form-control"
                                                       placeholder="Zip code"
                                                       v-model="agreement.pickup_address.zip" ref="pickup_address.zip"
                                                       :disabled="!isEditing" :class="{view: !isEditing}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.pickup_address.city=='' && isSubmit}">
                                                <input type="text" autocomplete="off" required class="form-control"
                                                       placeholder="City"
                                                       v-model="agreement.pickup_address.city" ref="pickup_address.city"
                                                       :disabled="!isEditing" :class="{view: !isEditing}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="agreement.pickup_address.country_id=='' && isSubmit? 'border-danger':''">
                                        <select class="form-control" v-model="agreement.pickup_address.country_id"
                                                ref="dropoff_address.country_id" :disabled="!isEditing"
                                                :class="{view: !isEditing}">
                                            <option value="1">Denmark</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="isEditing">
                                    ..or choose from existing: <br/>
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="agreement.existingPickupAddresses=='' && isSubmit? 'border-danger':''">
                                        <select @change="onChangePickupAddress($event)" class="form-control"
                                                v-model="agreement.existingPickupAddresses">
                                            <option v-for="item in JSON.parse(client).addresses"
                                                    v-if="item.type === 1  && item.deleted_at===null"
                                                    v-bind:value="item.id"
                                            >
                                                {{ item.name }} {{ item.street }}, {{ item.zip }} {{ item.city }},
                                                Denmark
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-4">
                                <div class="form-group">
                                    <div
                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.dropoff_address.name=='' && isSubmit}">
                                        <input type="text" autocomplete="off" required class="form-control"
                                               placeholder="name"
                                               v-model="agreement.dropoff_address.name" ref="dropoff_address.name"
                                               :disabled="!isEditing"
                                               :class="{view: !isEditing}">
                                        <div class="help-block with-errors"></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div
                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.dropoff_address.street=='' && isSubmit}">
                                        <input type="text" autocomplete="off" required class="form-control"
                                               placeholder="Address"
                                               v-model="agreement.dropoff_address.street"
                                               ref="dropoff_address.billing_street"
                                               :disabled="!isEditing" :class="{view: !isEditing}">
                                        <div class="help-block with-errors"></div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-4">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.dropoff_address.zip=='' && isSubmit}">
                                                <input type="text" autocomplete="off" required class="form-control"
                                                       placeholder="Zip code"
                                                       v-model="agreement.dropoff_address.zip" ref="dropoff_address.zip"
                                                       :disabled="!isEditing" :class="{view: !isEditing}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div
                                                :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': agreement.dropoff_address.city=='' && isSubmit}">
                                                <input type="text" autocomplete="off" required class="form-control"
                                                       placeholder="City"
                                                       v-model="agreement.dropoff_address.city"
                                                       ref="dropoff_address.city"
                                                       :disabled="!isEditing" :class="{view: !isEditing}">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="agreement.dropoff_address.country_id=='' && isSubmit? 'border-danger':''">
                                        <select class="form-control"
                                                v-model="agreement.dropoff_address.country_id"
                                                ref="dropoff_address.country_id"
                                                :disabled="!isEditing"
                                                :class="{view: !isEditing}"
                                        >
                                            <option value="1">Denmark</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="isEditing">
                                    ..or choose from existing: <br/>
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="agreement.existingDropoffAddresses=='' && isSubmit? 'border-danger':''">
                                        <select @change="onChangeDropoffAddress($event)" class="form-control"
                                                v-model="agreement.existingDropoffAddresses">
                                            <option v-for="item in JSON.parse(client).addresses"
                                                    v-if="item.type === 2 && item.deleted_at===null"
                                                    v-bind:value="item.id"
                                            >
                                                {{ item.name }} {{ item.street }}, {{ item.zip }} {{ item.city }},
                                                Denmark
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-2">
                                <div class="form-group">
                                    <div v-if="!isEditing">
                                        {{ agreement.primary_agreement === 1 ? 'Yes' : 'No' }}
                                    </div>
                                    <div v-else>
                                        <div v-if="agreement.primary_agreement === 1">
                                            <span class="oi oi-check"></span>
                                        </div>
                                        <div v-else>
                                            <input type="checkbox" v-model="agreement.primary_agreement">
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: 1.9rem"><strong>Agreement type: </strong></div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <select class="form-control"
                                                v-model="agreement.type"
                                                :disabled="!isEditing"
                                                :class="{view: !isEditing}"
                                        >
                                            <option v-for="(typeName, key) in types" :value="key">{{ typeName }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div><strong>Label format: </strong></div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <select class="form-control"
                                                v-model="agreement.label_format"
                                                :disabled="!isEditing"
                                                :class="{view: !isEditing}"
                                        >
                                            <option v-for="(name, key) in labelFormats" :value="key">
                                                {{ name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button type="submit" class="btn btn-primary mr-2"
                                        v-if="isEditing" @click="validation()">
                                    Save
                                </button>
                                <a v-if="isEditing" @click="isEditing = false">Cancel</a>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </form>

        <br/>
        <br/>

        <form @submit.prevent="updatePrices">
            <div class="p-4 mb-0 bg-white rounded-lg" ref="services">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="h4 mr-3">Products, services and prices</div>
                    <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="h4 mr-3">User type</div>
                        <div>
                            <select class="form-control" v-model="userType" style="width: 110px;" @change="onChangeUserType">
                                <option :value="key" v-for="(userType, key) in userTypes">{{ userType }}</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="container-fluid bg-light py-3">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-3">
                                <strong> Services </strong> <br>
                                <div v-for="item in services"
                                     v-if="item.service && item.service.id!=12 && item.service.deleted_at===null && item.user_type == userType"
                                >
                                    <label class="newInput">
                                        {{ item.service.name }}
                                        <input type="checkbox"
                                               name="serviceIds"
                                               :value="item.id"
                                               :checked="serviceIds.includes(item.id)"
                                               @change="onChangeId($event, 'service')"
                                        >
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <strong> Products </strong> <br>
                                <div v-for="item in products"
                                     v-if="item.product.deleted_at===null && item.user_type == userType"
                                >
                                    <label class="newInput">
                                        {{ item.product.name }}
                                        <input type="checkbox"
                                               name="productIds"
                                               :value="item.id"
                                               :checked="productIds.includes(item.id)"
                                               @change="onChangeId($event, 'product')"
                                        >
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <strong> Insurances </strong> <br>
                                <div v-for="item in insurances"
                                     v-if="item.user_type == userType"
                                >
                                    <label class="newInput">
                                        {{ item.insurance.name }}
                                        <input type="checkbox"
                                               name="insuranceIds"
                                               :value="item.id"
                                               :checked="insuranceIds.includes(item.id)"
                                               @change="onChangeId($event, 'insurance')"
                                        >
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-3"></div>

                        </div>
                    </div>
                </div>

                <div class="pt-4">
                    <div class="">
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <div class="btn mb-3 btn-success" @click="toggleModal">
                                    <i class="oi oi-plus" title="add interval"></i> Add new interval
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap">Intervals</strong>
                                    </div>
                                </div>
                                <table class="table border" aria-label="Intervals table">
                                    <thead>
                                    <tr>
                                        <th>
                                        </th>
                                        <th v-for="dimension in dimensions">
                                            <div v-if="dimension.id!==removeIntervalValue">
                                              <span
                                                  class="btn float-left btn-sm"
                                                  @click="removeIntervalColumn(dimension.id)">
                                                    <span class="material-icons-outlined text-danger  cursor-pointer"
                                                          title="delete interval">remove_circle</span>
                                                </span>
                                            </div>
                                            <div v-if="dimension.id===removeIntervalValue">
                                                <a href="#" @click="cancelRemoveIntervalColumn">
                                                    cancel deleting
                                                </a>
                                            </div>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-bordered">
                                    <tr>
                                        <td style="width: 20%">
                                            Max volume
                                        </td>
                                        <td style="width: 10%" v-for="dimension in dimensions">
                                            <div v-if="dimension.id!==removeIntervalValue">
                                                {{ dimension.max_volume|number }}cbm
                                            </div>
                                            <div v-if="dimension.id===removeIntervalValue">
                                                            <span
                                                                class="material-icons-outlined text-danger  cursor-pointer">remove_circle</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Max weight
                                        </td>
                                        <td v-for="dimension in dimensions">
                                            <div v-if="dimension.id!==removeIntervalValue">
                                                {{ dimension.max_weight|number }}kg
                                            </div>
                                            <div v-if="dimension.id===removeIntervalValue">
                                                            <span
                                                                class="material-icons-outlined text-danger  cursor-pointer">remove_circle</span>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <br/>
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap">Products (ground price)</strong>
                                        <div v-if="removeInterval===false">
                                            <span class="product-price"></span>
                                            <span
                                                class="material-icons-outlined text-danger  cursor-pointer"
                                                @click="scrollToService({behavior: 'smooth'},'product-price');
                                                       isEditingProductPrice = !isEditingProductPrice"
                                                v-if="!isEditingProductPrice"
                                                title="edit">edit
                                            </span>
                                            <span
                                                ref="cancelEditing"
                                                v-if="isEditingProductPrice"
                                                @click="scrollToService({behavior: 'smooth'},'product-price');
                                                        isEditingProductPrice = false">
                                                        Cancel
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <table class="table border" aria-label="Products table">
                                    <tbody class="table-bordered">
                                    <tr v-if="product.active===1 && userType == product.user_type"
                                        v-for="(product, productindex) of agreement.products">
                                        <td style="width: 20%">
                                            {{ product.product.name }}
                                        </td>
                                        <td style="width: 10%" v-if="item.interval.agreement_id==agreement.id"
                                            v-for="(item, index) of product.prices">
                                            <div class="form-group">
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProductPrice}">
                                                    <input
                                                        class="form-control border-0 py-0 shadow-none form-input"
                                                        v-model="product.prices[index].price"
                                                        v-number
                                                        :disabled="!isEditingProductPrice"
                                                        :class="{view: !isEditingProductPrice}"
                                                    >
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    </tbody>
                                </table>

                                <br/>
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap"> Services (add-on fee) </strong>
                                        <span class="service-price"></span>
                                        <div v-if="removeInterval===false">
                                            <div v-if="removeInterval===false">
                                                <span
                                                    class="material-icons-outlined text-danger  cursor-pointer"
                                                    @click="scrollToService({behavior: 'smooth'},'service-price');
                                                    isEditingServicePrice = !isEditingServicePrice"
                                                    v-if="!isEditingServicePrice"
                                                    title="edit">edit
                                                </span>

                                                <span
                                                    ref="cancelEditing"
                                                    v-if="isEditingServicePrice"
                                                    @click="scrollToService({behavior: 'smooth'},'service-price');
                                                        isEditingServicePrice = false">
                                                        Cancel
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <table class="table border" aria-label="Services table">
                                    <tbody class="table-bordered">
                                    <tr v-if="service.active===1 && userType == service.user_type"
                                        v-for="service in agreement.services"
                                    >
                                        <td style="width: 20%">
                                            {{ service.service ? service.service.name : '' }}
                                        </td>
                                        <td style="width: 10%" v-if="item.interval.agreement_id==agreement.id"
                                            v-for="(item, index) of service.prices">
                                            <div class="form-group">
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingServicePrice}">
                                                    <input type="text"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="service.prices[index].price"
                                                           v-number
                                                           :disabled="!isEditingServicePrice"
                                                           :class="{view: !isEditingServicePrice}"
                                                    >
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <br/>
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap"> Insurances (add-on fee) </strong>
                                        <span class="insurance-price"></span>
                                        <div v-if="removeInterval===false">
                                            <span
                                                class="material-icons-outlined text-danger  cursor-pointer"
                                                @click="scrollToService({behavior: 'smooth'},'insurance-price');
                                                isEditingInsurancePrice = !isEditingInsurancePrice"
                                                v-if="!isEditingInsurancePrice"
                                                title="edit">edit
                                            </span>

                                            <span
                                                ref="cancelEditing"
                                                v-if="isEditingInsurancePrice"
                                                @click="scrollToService({behavior: 'smooth'},'insurance-price');
                                                    isEditingInsurancePrice = false">
                                                    Cancel
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <table class="table border">
                                    <tbody class="table-bordered">
                                    <tr v-if="insurance.active===1 && userType == insurance.user_type"
                                        v-for="insurance in agreement.insurances"
                                    >
                                        <td style="width: 20%">
                                            {{ insurance.insurance.name }}
                                        </td>
                                        <td style="width: 10%" v-if="item.interval.agreement_id == agreement.id"
                                            v-for="(item, index) of insurance.prices">
                                            <div class="form-group">
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingInsurancePrice}">
                                                    <input type="text"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           v-model="insurance.prices[index].price"
                                                           :disabled="!isEditingInsurancePrice"
                                                           :class="{view: !isEditingInsurancePrice}"
                                                    >
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br/>

                        <div class="row">
                            <div class="col-md-4">
                                <button class="btn float-left btn-success btn-lg">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </form>

        <a href="/clients" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center mt-3">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>


        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create new interval</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addNewInterval">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDimensions.max_volume=='' && isSubmitNew? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Max volume"
                                           v-model="newDimensions.max_volume"
                                           v-number
                                           ref="newDimensions.volume"
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDimensions.max_weight=='' && isSubmitNew? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none"
                                           placeholder="Max weight"
                                           v-model="newDimensions.max_weight"
                                           v-number
                                           ref="newDimensions.weight"
                                    >
                                </div>
                            </div>

                            <button class="btn btn-primary" @click="validationInterval()">
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "AgreementEdit",
    props: {
        url: {type: String, required: true},
        client: {type: String, required: true},
        types: {type: Object, required: true},
        userTypes: {type: Object, required: true},
        userTypeClient: {type: String, required: true},
        userTypeCustomer: {type: String, required: true},
        labelFormats: {type: Object, required: true},
    },
    data() {
        return {
            address: JSON.parse(this.client).addresses,
            isEditing: false,
            agreement: {
                pickup_address:
                    {
                        country_id: 1,
                        name: ''
                    },
                dropoff_address:
                    {
                        country_id: 1,
                        name: ''
                    }
            },
            products: [],
            services: [],
            insurances: [],
            activeModalInterval: false,
            show: false,
            isEditingProduct: false,
            isEditingService: false,
            isEditingProductPrice: false,
            isEditingServicePrice: false,
            isEditingInsurancePrice: false,
            intervals: {'price_type': 1},
            removeInterval: false,
            removeIntervalValue: '',
            priceType: 1,
            price: {},
            newDimensions: {},
            dimensions: {},
            agreementServices: {},
            productIds: [],
            serviceIds: [],
            insuranceIds: [],
            isSubmit: false,
            isSubmitNew: false,
            userType: Object.keys(this.userTypes)[0]
        }
    },
    methods: {
        validationInterval() {
            this.isSubmitNew = true;
        },
        validation() {
            this.isSubmit = true;
        },
        updateAgreement() {
            axios.patch(`/agreements/${this.agreement.id}`, this.agreement).then((response) => {
                this.isEditing = !this.isEditing;
                window.location.href = `/agreements/${response.data.agreementId}/edit`;
            }).catch(err => console.log(err))
        },
        fetchData() {
            let dataFetchUrl = `${this.url}`
            axios.get(dataFetchUrl)
                .then(({data}) => {
                    this.agreement = data.agreement;
                    this.products = data.agreement.products;
                    this.services = data.agreement.services;
                    this.insurances = data.agreement.insurances;
                    axios.get(`/intervals-list/${data.agreement.id}`)
                        .then(({data}) => {
                            this.dimensions = data.data;
                        }).catch(error => this.dimensions = []);
                    axios.get(`/agreement-products/${data.agreement.id}`)
                        .then(({data}) => {
                            this.productIds = data;
                        }).catch(error => this.productIds = []);
                    axios.get(`/agreement-services/${data.agreement.id}`)
                        .then(({data}) => {
                            this.serviceIds = data;
                        }).catch(error => this.serviceIds = []);
                    axios.get(`/agreement-insurances/${data.agreement.id}`)
                        .then(({data}) => {
                            this.insuranceIds = data;
                        }).catch(error => this.insuranceIds = []);
                }).catch(error => this.agreement = []);
        },
        onChangePickupAddress(event) {
            let addressData = this.address.filter(p => p.id == event.target.value);

            if (addressData.length > 0) {
                this.agreement.pickup_address.name = addressData[0].name;
                this.agreement.pickup_address.street = addressData[0].street;
                this.agreement.pickup_address.zip = addressData[0].zip;
                this.agreement.pickup_address.city = addressData[0].city;
                this.agreement.pickup_address.country_id = 1;
            }
        },
        onChangeDropoffAddress(event) {
            let addressData = this.address.filter(p => p.id == event.target.value);
            if (addressData.length > 0) {
                this.agreement.dropoff_address.name = addressData[0].name;
                this.agreement.dropoff_address.street = addressData[0].street;
                this.agreement.dropoff_address.zip = addressData[0].zip;
                this.agreement.dropoff_address.city = addressData[0].city;
                this.agreement.dropoff_address.country_id = 1;
            }
        },
        updatePrices() {
            if (this.removeIntervalValue > 0) {
                axios.delete(`/interval/${this.removeIntervalValue}/${this.agreement.id}`).then((response) => {
                    window.location.reload();
                }).catch(err => console.log(err))
            } else {
                axios.patch(`/save-agreement-products/${this.agreement.id}`, this.productIds).then((response) => {
                }).catch(err => console.log(err));
                axios.patch(`/save-agreement-services/${this.agreement.id}`, this.serviceIds).then((response) => {
                }).catch(err => console.log(err));
                axios.patch(`/save-agreement-insurances/${this.agreement.id}`, this.insuranceIds).then((response) => {
                }).catch(err => console.log(err));
                axios.patch(`/save-agreement-products-prices/${this.agreement.id}`, this.agreement.products).then((response) => {
                }).catch(err => console.log(err));
                axios.patch(`/save-agreement-services-prices/${this.agreement.id}`, this.agreement.services).then((response) => {
                }).catch(err => console.log(err));
                axios.patch(`/save-agreement-insurances-prices/${this.agreement.id}`, this.agreement.insurances).then((response) => {
                }).catch(err => console.log(err));

                setTimeout(() => {
                    window.location.reload();
                }, 500)
            }
        },
        addNewInterval: function () {
            axios.post(`/new-interval/${this.agreement.id}`, this.newDimensions).then((response) => {
                if (response.data.result === 'error') {
                    alert(response.data.message);
                } else {
                    window.location.reload();
                }
            }).catch(err => console.log(err))
        },
        removeIntervalColumn: function (value) {
            this.removeInterval = true;
            this.removeIntervalValue = value;
        },
        cancelRemoveIntervalColumn: function (value) {
            this.removeInterval = false;
            this.removeIntervalValue = '';
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        onChangeId(event, entity) {
            const entityIds = `${entity}Ids`
            let value = parseInt(event.target.value);
            let index = this[entityIds].indexOf(value);
            if (index !== -1) {
                this[entityIds].splice(index, 1);
            } else {
                this[entityIds].push(value)
            }
        },
        scrollToService(options, elementToScroll) {
            const el = this.$el.getElementsByClassName(elementToScroll)[0];
            if (el) {
                el.scrollIntoView(options);
            }
        },
        onChangeUserType() {
            let formatedPrice;
            this.agreement.insurances.forEach((item, key) => {
                if (item.active) {
                    item.prices.forEach((priceItem, priceKey) => {
                        const currentPrice = String(priceItem.price);

                        // Skip if already contains a comma (Danish format)
                        if (!currentPrice.includes(',')) {
                            const number = parseFloat(currentPrice);
                            const decimalPart = currentPrice.split('.')[1];

                            // If it's an integer or has exactly 2 decimal places
                            if (!decimalPart || decimalPart.length <= 2) {
                                // Format with thousand separators
                                formatedPrice = number.toLocaleString('da-DK', {
                                    minimumFractionDigits: decimalPart ? 2 : 0,
                                    maximumFractionDigits: 2
                                });
                                this.$set(this.agreement.insurances[key].prices[priceKey], 'price', formatedPrice);
                            }
                        }
                    });
                }

            });

        }
    },
    created() {
        return this.fetchData()
    },
    filters: {
        number: function (value) {
            return value.toLocaleString('da-DK');
        }
    },
}
</script>
